import * as OBC from '@thatopen/components';
import * as THREE from 'three';

const DB_NAME = 'ModelCacheDB';
const STORE_NAME = 'models';

const openDatabase = (): Promise<IDBDatabase> => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, 1);

        request.onerror = (event) => {
            reject('Failed to open IndexedDB');
        };

        request.onsuccess = (event) => {
            resolve(request.result);
        };

        request.onupgradeneeded = (event) => {
            const db = request.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'url' });
            }
        };
    });
};

const storeModel = async (url: string, buffer: Uint8Array) => {
    const db = await openDatabase();
    const transaction = db.transaction(STORE_NAME, 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    store.put({ url, buffer });
};

const retrieveModel = async (url: string): Promise<Uint8Array | null> => {
    const db = await openDatabase();
    return new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, 'readonly');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.get(url);

        request.onerror = () => {
            reject('Failed to retrieve model from IndexedDB');
        };

        request.onsuccess = () => {
            resolve(request.result ? request.result.buffer : null);
        };
    });
};

export default async function loadFragmentsFromUri(uri: string, world: OBC.World, components: OBC.Components, id: number) {
    const fragments = components.get(OBC.FragmentsManager);

    let buffer = await retrieveModel("https://models/"+id);
    if (!buffer) {
        console.log('Fetching and caching model:', uri);
        const response = await fetch(uri);
        const data = await response.arrayBuffer();
        buffer = new Uint8Array(data);
        await storeModel("https://models/"+id, buffer);
    } else {
        console.log('Model retrieved from IndexedDB:', uri);
    }

    const group = fragments.load(buffer);
    world.scene.three.add(group);

    const scene = world.scene;
    const box = new THREE.Box3();

    // Calculate the bounding box for all direct children
    scene.three.children.forEach(child => {
        box.expandByObject(child);
    });

    const sceneSize = new THREE.Vector3();
    box.getSize(sceneSize);
    const sceneCenter = new THREE.Vector3();
    box.getCenter(sceneCenter);
    const nearFactor = 0.9;
    const radius = Math.max(sceneSize.x, sceneSize.y, sceneSize.z) * nearFactor;
    const sphere = new THREE.Sphere(sceneCenter, radius);

    world.camera.controls?.fitToSphere(sphere, true);
    //@ts-ignore
    world.meshes.add(group);

    return group;
}